/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeOptionPicker } from '@base/react';
import React from 'react';

function UfFilterDisabled({ defaultUf }) {
  return (
    <div>
      <BaSeOptionPicker
        label="UF do seminário:"
        values={defaultUf}
        isDisabled
        emptyValueLabel="UF"
        maxOptionsSelected={1}
        onChange={(values) => console.log(values)}
        initialSelectedValuesId={defaultUf.map((i) => i.id)}
      />
    </div>
  );
}

export default UfFilterDisabled;
